export const sceneDataMap = {
  BUSINESS_CONTENT: {
    value: 'BUSINESS_CONTENT',
    label: '应用内容',
    user: ['image', 'audio', 'document', 'video', 'animation'],
  },
  COURSE_COVER: {
    value: 'COURSE_COVER',
    label: '课程封面',
    user: ['image'],
  },
  COURSE_CATALOGUE_COVER: {
    value: 'COURSE_CATALOGUE_COVER',
    label: '目录封面',
    user: ['image'],
  },
  BUSINESS_CATALOGUE_COVER: {
    value: 'BUSINESS_CATALOGUE_COVER',
    label: '合集封面',
    user: ['image'],
  },
  TEACHING_RESOURCE: {
    value: 'TEACHING_RESOURCE',
    label: '课程资源',
    user: ['image', 'audio', 'document', 'video', 'animation'],
  },
  BUSINESS_CATALOGUE_BACKGROUND: {
    value: 'BUSINESS_CATALOGUE_BACKGROUND',
    label: '合集背景',
    user: ['image'],
  },
  TEMPLATE: {
    value: 'TEMPLATE',
    label: '模版',
    user: ['audio'],
  },
};
